<template>
  <div v-if="layout == 'default'" :class="containerClass">
    <ec-flex :justify="titleAlign" :style="titleStyle">
      <ec-flex :hGap="0" alignItems="center" style="margin-right: 16px">
        <div class="fb-title">{{ title }}</div>
        <div v-if="required" style="color: red">*</div>
      </ec-flex>
      <slot name="action"></slot>
    </ec-flex>
    <div class="flex-row-nowrap-start-start-start" style="line-height: 34px; width: 100%">
      <slot></slot>
    </div>
  </div>

  <ec-flex v-if="layout == 'cell'" full alignItems="center">
    <div class="fb-title">{{ title }}</div>
    <div v-if="contentAlign !== 'left'" style="flex-grow: 1"></div>
    <slot></slot>
    <div v-if="contentAlign === 'center'" style="flex-grow: 1"></div>
  </ec-flex>
</template>
<script lang="ts" setup>
import { computed } from "vue"

const props = withDefaults(
  defineProps<{
    title: string
    titleAlign?: string
    vertical?: boolean
    titleWidth?: number | string
    titleFontSize?: number | string
    minHeight?: number
    required?: boolean
    forceWidth?: boolean
    layout?: "default" | "cell"
    contentAlign?: "left" | "center" | "right"
  }>(),
  {
    titleAlign: "start",
    vertical: false,
    titleWidth: 150,
    titleFontSize: 14,
    minHeight: 34,
    required: false,
    forceWidth: true,
    layout: "default",
    contentAlign: "right",
  },
)

const containerClass = computed(() => {
  if (props.vertical) {
    return "flex-col-nowrap-start-start-start"
  } else {
    return "flex-row-nowrap-start-start-start"
  }
})

const titleStyle = computed(() => {
  let width = "100%"
  width = typeof props.titleWidth === "number" ? `${props.titleWidth}px` : props.titleWidth
  const fontSize = typeof props.titleFontSize === "number" ? `${props.titleFontSize}px` : props.titleFontSize // 已经是字符串，如 "1.2rem" 或 "16px"
  return {
    "min-width": width,
    "font-size": fontSize,
    "min-height": `${props.minHeight}px`,
    "flex-shrink": 0,
  }
})
</script>
<style scoped>
.fb-title-container {
  flex-shrink: 0;
}
.fb-title {
  color: #777;
  flex-shrink: 0;
  text-align: center;
  line-height: 34px;
}
</style>
